import { ProductState, ProductStateStatus } from 'protocol/api/billing_new/dto_product_new_pb';

export const isProductActive = (product: ProductState) =>
  product.Status === ProductStateStatus.ProductStateStatusActive &&
  (!product.Start || product.Start.toDate() <= new Date());
